/*
 *
 * LanguageProvider actions
 *
 */

import * as types from "./constants";

export function changeLocale(languageLocale) {
  return {
    type: types.CHANGE_LOCALE,
    locale: languageLocale
  };
}

export function getLocizeMessage({ locale, isSkip = false, locizeApi }) {
  if (isSkip || !locizeApi) {
    return {
      type: types.GET_LOCIZE_MESSAGE_SKIP
    };
  }
  return {
    type: types.GET_LOCIZE_MESSAGE_REQUEST,
    locale,
    locizeApi
  };
}

export const getSupportedLocales = ({
  supportedLocalesApi,
  isSkip = false
}) => {
  if (isSkip) {
    return {
      type: types.GET_SUPPORTED_LOCALES_SKIP
    };
  }
  return {
    type: types.GET_SUPPORTED_LOCALES_REQUEST,
    supportedLocalesApi
  };
};
